import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'uppercaseFirst',
})
export class uppercaseFirstPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
